export const tableschema3 = {
    "name_table": "Розділ III. Кількість дітей з особливими освітніми потребами (ООП)",
    "titles": [
        "Усього у тому числі за категоріями (типами) ООП (труднощів)",
        "інтелектуальні труднощі",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "функціональні труднощі",
        "у тому числі",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "слухової функції",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "зорової функції",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "моторні",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "мовленнєві",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "фізичні труднощі",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "навчальні труднощі",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки",
        "соціоадаптаційні (соціокультурні) труднощі",
        "з них",
        "2 рівень підтримки",
        "3 рівень підтримки",
        "4 рівень підтримки",
        "5 рівень підтримки"
    ],
    "parts": [
        {
            "title": "Усього дітей з ООП, осіб",
            "subtitle": "",
            "fields": [
                "OOP11",
                "OOP21",
                "OOP31",
                "OOP41",
                "OOP51",
                "OOP61",
                "OOP71",
                "OOP81",
                "OOP91",
                "OOP101",
                "OOP111",
                "OOP121",
                "OOP131",
                "OOP141",
                "OOP151",
                "OOP161",
                "OOP171",
                "OOP181",
                "OOP191",
                "OOP201",
                "OOP211",
                "OOP221",
                "OOP231",
                "OOP241",
                "OOP251",
                "OOP261",
                "OOP271",
                "OOP281",
                "OOP291",
                "OOP301",
                "OOP311",
                "OOP321",
                "OOP331",
                "OOP341",
                "OOP351",
                "OOP361",
                "OOP371",
                "OOP381",
                "OOP391",
                "OOP401",
                "OOP411",
                "OOP421",
                "OOP431",
                "OOP441",
                "OOP451",
                "OOP461",
                "OOP471",
                "OOP481",
                "OOP491",
                "OOP501",
                "OOP511",
                "OOP521",
                "OOP531",
                "OOP541",
                "OOP551",
                "OOP561"
            ]
        },
        {
            "title": "За віком",
            "subtitle": "до 3 років",
            "fields": [
                "OOP12",
                "OOP22",
                "OOP32",
                "OOP42",
                "OOP52",
                "OOP62",
                "OOP72",
                "OOP82",
                "OOP92",
                "OOP102",
                "OOP112",
                "OOP122",
                "OOP132",
                "OOP142",
                "OOP152",
                "OOP162",
                "OOP172",
                "OOP182",
                "OOP192",
                "OOP202",
                "OOP212",
                "OOP222",
                "OOP232",
                "OOP242",
                "OOP252",
                "OOP262",
                "OOP272",
                "OOP282",
                "OOP292",
                "OOP302",
                "OOP312",
                "OOP322",
                "OOP332",
                "OOP342",
                "OOP352",
                "OOP362",
                "OOP372",
                "OOP382",
                "OOP392",
                "OOP402",
                "OOP412",
                "OOP422",
                "OOP432",
                "OOP442",
                "OOP452",
                "OOP462",
                "OOP472",
                "OOP482",
                "OOP492",
                "OOP502",
                "OOP512",
                "OOP522",
                "OOP532",
                "OOP542",
                "OOP552",
                "OOP562"
            ]
        },
        {
            "title": "За віком",
            "subtitle": "старше 3 років",
            "fields": [
                "OOP13",
                "OOP23",
                "OOP33",
                "OOP43",
                "OOP53",
                "OOP63",
                "OOP73",
                "OOP83",
                "OOP93",
                "OOP103",
                "OOP113",
                "OOP123",
                "OOP133",
                "OOP143",
                "OOP153",
                "OOP163",
                "OOP173",
                "OOP183",
                "OOP193",
                "OOP203",
                "OOP213",
                "OOP223",
                "OOP233",
                "OOP243",
                "OOP253",
                "OOP263",
                "OOP273",
                "OOP283",
                "OOP293",
                "OOP303",
                "OOP313",
                "OOP323",
                "OOP333",
                "OOP343",
                "OOP353",
                "OOP363",
                "OOP373",
                "OOP383",
                "OOP393",
                "OOP403",
                "OOP413",
                "OOP423",
                "OOP433",
                "OOP443",
                "OOP453",
                "OOP463",
                "OOP473",
                "OOP483",
                "OOP493",
                "OOP503",
                "OOP513",
                "OOP523",
                "OOP533",
                "OOP543",
                "OOP553",
                "OOP563"
            ]
        },
        {
            "title": "З них",
            "subtitle": "в групах загального розвитку",
            "fields": [
                "OOP14",
                "OOP24",
                "OOP34",
                "OOP44",
                "OOP54",
                "OOP64",
                "OOP74",
                "OOP84",
                "OOP94",
                "OOP104",
                "OOP114",
                "OOP124",
                "OOP134",
                "OOP144",
                "OOP154",
                "OOP164",
                "OOP174",
                "OOP184",
                "OOP194",
                "OOP204",
                "OOP214",
                "OOP224",
                "OOP234",
                "OOP244",
                "OOP254",
                "OOP264",
                "OOP274",
                "OOP284",
                "OOP294",
                "OOP304",
                "OOP314",
                "OOP324",
                "OOP334",
                "OOP344",
                "OOP354",
                "OOP364",
                "OOP374",
                "OOP384",
                "OOP394",
                "OOP404",
                "OOP414",
                "OOP424",
                "OOP434",
                "OOP444",
                "OOP454",
                "OOP464",
                "OOP474",
                "OOP484",
                "OOP494",
                "OOP504",
                "OOP514",
                "OOP524",
                "OOP534",
                "OOP544",
                "OOP554",
                "OOP564"
            ]
        },
        {
            "title": "З них",
            "subtitle": "в інклюзивних групах",
            "fields": [
                "OOP15",
                "OOP25",
                "OOP35",
                "OOP45",
                "OOP55",
                "OOP65",
                "OOP75",
                "OOP85",
                "OOP95",
                "OOP105",
                "OOP115",
                "OOP125",
                "OOP135",
                "OOP145",
                "OOP155",
                "OOP165",
                "OOP175",
                "OOP185",
                "OOP195",
                "OOP205",
                "OOP215",
                "OOP225",
                "OOP235",
                "OOP245",
                "OOP255",
                "OOP265",
                "OOP275",
                "OOP285",
                "OOP295",
                "OOP305",
                "OOP315",
                "OOP325",
                "OOP335",
                "OOP345",
                "OOP355",
                "OOP365",
                "OOP375",
                "OOP385",
                "OOP395",
                "OOP405",
                "OOP415",
                "OOP425",
                "OOP435",
                "OOP445",
                "OOP455",
                "OOP465",
                "OOP475",
                "OOP485",
                "OOP495",
                "OOP505",
                "OOP515",
                "OOP525",
                "OOP535",
                "OOP545",
                "OOP555",
                "OOP565"
            ]
        },
        {
            "title": "З них",
            "subtitle": "в спеціальних групах",
            "fields": [
                "OOP16",
                "OOP26",
                "OOP36",
                "OOP46",
                "OOP56",
                "OOP66",
                "OOP76",
                "OOP86",
                "OOP96",
                "OOP106",
                "OOP116",
                "OOP126",
                "OOP136",
                "OOP146",
                "OOP156",
                "OOP166",
                "OOP176",
                "OOP186",
                "OOP196",
                "OOP206",
                "OOP216",
                "OOP226",
                "OOP236",
                "OOP246",
                "OOP256",
                "OOP266",
                "OOP276",
                "OOP286",
                "OOP296",
                "OOP306",
                "OOP316",
                "OOP326",
                "OOP336",
                "OOP346",
                "OOP356",
                "OOP366",
                "OOP376",
                "OOP386",
                "OOP396",
                "OOP406",
                "OOP416",
                "OOP426",
                "OOP436",
                "OOP446",
                "OOP456",
                "OOP466",
                "OOP476",
                "OOP486",
                "OOP496",
                "OOP506",
                "OOP516",
                "OOP526",
                "OOP536",
                "OOP546",
                "OOP556",
                "OOP566"
            ]
        }
    ],
    "shorts": {
        "titles": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6",
            "7",
            "8",
            "9",
            "10",
            "11",
            "12",
            "13",
            "14",
            "15",
            "16",
            "17",
            "18",
            "19",
            "20",
            "21",
            "22",
            "23",
            "24",
            "25",
            "26",
            "27",
            "28",
            "29",
            "30",
            "31",
            "32",
            "33",
            "34",
            "35",
            "36",
            "37",
            "38",
            "39",
            "40",
            "41",
            "42",
            "43",
            "44",
            "45",
            "46",
            "47",
            "48",
            "49",
            "50",
            "51",
            "52",
            "53",
            "54",
            "55",
            "56"
        ],
        "parts": [
            "1",
            "2",
            "3",
            "4",
            "5",
            "6"
        ]
    }
};